import BaseService from "./base.service";
import { Singleton } from "util";

@Singleton
export default class PaymentInfoService extends BaseService {
  async update(companyUuid, params) {
    return await super.update(`/v1/payment_infos/${companyUuid}`, params);
  }

  async deletePaymentInfo(companyUuid) {
    return await this.destroy(`/v1/payment_infos/${companyUuid}`);
  }
}



// WEBPACK FOOTER //
// ./src/core/service/payment-info.service.js